// ignore-string-externalization
import '@spotify-internal/css-physical-to-logical/css/styles.css';
import React from 'react';
import { AppProps, AppContext, AppInitialProps } from 'next/app';
import { StyleSheetManager } from 'styled-components';
import type { Middleware } from 'stylis';
import { stylisPhysicalToLogical } from '@spotify-internal/css-physical-to-logical';
import isPropValid from '@emotion/is-prop-valid';

type AppType = React.ComponentType<AppProps> & {
  getInitialProps?: (
    context: AppContext,
  ) => AppInitialProps | Promise<AppInitialProps>;
};

Object.defineProperty(stylisPhysicalToLogical, 'name', {
  value: 'stylisPhysicalToLogical',
});

const stylisPlugins: Middleware[] = [stylisPhysicalToLogical as any];

function shouldForwardProp(prop: string, target: unknown): boolean {
  if (typeof target === 'string') {
    return isPropValid(prop);
  }
  return true;
}

export function appWithCssTransform(WrappedApp: AppType): AppType {
  function AppWithCssTransform(props: AppProps) {
    return (
      <StyleSheetManager
        stylisPlugins={stylisPlugins}
        shouldForwardProp={shouldForwardProp}
      >
        <WrappedApp {...props} />
      </StyleSheetManager>
    );
  }

  AppWithCssTransform.getInitialProps = WrappedApp.getInitialProps;

  return AppWithCssTransform;
}
